import PropTypes from 'prop-types';import { Modal } from './Modal.jsx';
import ModalHeader from './ModalHeader.jsx';
import { CustomButton } from './CustomButton.jsx';

function SignInPromptModal({ isOpened, setIsOpened, title, bodyText }) {
    return (        <Modal isOpened={isOpened} setIsOpened={setIsOpened}>
            <ModalHeader title={title} type="warning" setIsOpened={setIsOpened}/>
            <div className="modal__content sing-in-modal">
                <p className="need_sign_in__text">{bodyText}</p>
                <div className="modal__buttons">
                    <CustomButton
                        text="Sign in"
                        styleType="primary"
                        onClick={() => {
                            setIsOpened(false);
                            window.location.assign('/login');
                        }}
                    />
                    <CustomButton
                        text="Cancel"
                        styleType="secondary"
                        onClick={() => setIsOpened(false)}
                    />
                </div>
                <p className="additional-text">
                    <a href="/signup">Don’t have an account? <span>Sign up</span></a>
                </p>
            </div>
        </Modal>
    );
}

SignInPromptModal.propTypes = {
    isOpened: PropTypes.bool.isRequired,
    setIsOpened: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    bodyText: PropTypes.string.isRequired,
};

/** Header / Footer: opening Saved Jewelry or Followed Brands while logged out */
export function SignInForCollectionNavModal({ isOpened, setIsOpened }) {
    return (
        <SignInPromptModal
            isOpened={isOpened}
            setIsOpened={setIsOpened}
            title="Sign in to continue"
            bodyText="Please log in to open Saved Jewelry and Followed Brands."
        />
    );
}

SignInForCollectionNavModal.propTypes = {
    isOpened: PropTypes.bool.isRequired,
    setIsOpened: PropTypes.func.isRequired,
};

